import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { Action, Amount, Currency, DiasporaStagingResponse, FlowCode, OrchestrationRequest, OrchestrationResponse, OrderStatus, PaymentDetails, StatusMode } from '../general.model';
import { InstantBankTransferService } from '../instant-bank-transfer.service';
import { TransactionService } from '../transaction/transaction.service';
import { AuthService } from '../transaction/auth.service';


@Component({
  selector: 'app-authorize-payment',
  standalone: true,
  imports: [CheckboxModule,CommonModule,FormsModule,ButtonModule],
  templateUrl: './authorize-payment.component.html',
  styleUrl: './authorize-payment.component.css'
})
export class AuthorizePaymentComponent {

  constructor(private router: Router,
              private instantBankTransferService: InstantBankTransferService,
              private transactionService: TransactionService,
            private authService: AuthService) {

  }

  agreed = true;
  
  proceed() {
    console.log('Proceed');
    //this.router.navigate(['/']);
    let amount:Amount = {currency:this.instantBankTransferService.data()?.currency as Currency,
      value:this.instantBankTransferService.data()?.amount};
    this.transactionService.getPayment(this.authService?.uuid() ?? '', StatusMode.SAVED).subscribe({
        next: (response) => {
            let diasporaStagingResponse:DiasporaStagingResponse = response;
            if(diasporaStagingResponse?.bankRedirectUrl){
              window.location.href = diasporaStagingResponse.bankRedirectUrl;
            }
            console.log('Data received:', response);
        },
        error: (err) => {
            this.router.navigate(['/service-unavailable']);
            console.error('Error occurred:', err);
        }
    });

  }


}
